import qs from 'qs';
import { finalizeResponse, handleError } from 'tradera/utils/api';
import { touchWebClient, webApiClient } from 'tradera/utils/http';
import { removePropertiesWithoutValue } from 'tradera/utils/object';

export const fetchReviews = (feedbackIds, toLanguageCodeIso2) => {
    const query = qs.stringify(
        { feedbackIds, toLanguageCodeIso2 },
        { arrayFormat: 'repeat' }
    );
    const queryPart = query ? `?${query}` : '';
    const url = `/member/feedback/translated${queryPart}`;
    return webApiClient.get(url).then(finalizeResponse()).catch(handleError());
};

export const fetchProfileModel = ({ memberId, role, rating, page }) => {
    const query = new URLSearchParams(
        removePropertiesWithoutValue({
            memberId,
            role,
            rating,
            page
        })
    ).toString();
    const queryPart = query ? `?${query}` : '';
    return touchWebClient
        .get(`/profile/model/${memberId}${queryPart}`)
        .then(finalizeResponse())
        .catch(handleError());
};

export const postFeedbackReply = async (gradeId, comment) =>
    touchWebClient.post('/profile/feedback/reply-to-negative-feedback', {
        comment,
        gradeId
    });
